<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="116" height="99" viewBox="0 0 116 99" fill="none">
        <circle opacity="0.1" cx="38" cy="21" r="78" fill="url(#paint0_linear_5164_11374)" />
        <defs>
            <linearGradient id="paint0_linear_5164_11374" x1="18.5" y1="21" x2="92.8108" y2="82.6622"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#9D9D9D" stop-opacity="0" />
                <stop offset="1" stop-color="white" />
            </linearGradient>
        </defs>
    </svg>
</template>